import React, { useEffect, useState } from 'react'
import './styles.scss'

export interface BeaconProps {
  state: 'thinking' | 'processing' | 'idle'
}

const Beacon = ({ state }: BeaconProps): JSX.Element => {
  const [dots, setDots] = useState(0)

  useEffect(() => {
    if (state === 'idle') {
      setDots(0)
      return
    }
    const interval = setInterval(() => {
      setDots((prev) => (prev < 3 ? prev + 1 : 0))
    }, 500)
    return () => clearInterval(interval)
  }, [state])

  return (
    <>
      <span className='Beacon'></span>
      <span>
        {state === 'processing'
          ? 'Processing your request'
          : state === 'idle'
          ? 'Ready'
          : state}
        {'.'.repeat(dots)}
      </span>
    </>
  )
}

export default Beacon
